<div class="page">
  <div class="layout">
    <div class="left-side">
      <img class="logo" src="../../../../../assets/images/logo2.svg" alt="" />
      <div class="vector-layer">
        <img
          class="left-image"
          src="../../../assets/vectors/auth-vector-2.svg"
          alt=""
        />
      </div>
      <div class="base-layer">
        <div class="base-text">
          <span class="base-title"
            >Streamlining Efficiencies in Webhook Management</span
          >
          <span class="base-label">
            Webhook Manager simplifies setup, monitoring, and optimization with a
            user-friendly interface, ensuring seamless communication, real-time
            data sync, and instant notifications. Elevate efficiency
            effortlessly.
          </span>
        </div>
      </div>
    </div>
    <div class="right-side">
      <img class="logo" src="../../../../../assets/images/logo.svg" alt="" />
      <div class="form-holder">
        <p-toast></p-toast>
        <div class="form-container">
          <h1 class="form-head">Create Account</h1>
          <p class="form-sub-head">Create an account to get started.</p>
          <div class="form-content">
            <app-error-message [message]="errorMessage"></app-error-message>
            <div class="sub-form full-width">
              <div class="input-holder half-width">
                <app-input
                  class="input"
                  (dataEvent)="firstName($event)"
                  label="First Name"
                  placeholder="John"
                ></app-input>
              </div>
              <div class="input-holder half-width">
                <app-input
                  class="input"
                  (dataEvent)="lastName($event)"
                  label="Last Name"
                  placeholder="Doe"
                ></app-input>
              </div>
              <div class="input-holder half-width">
                <app-input
                  class="input"
                  (dataEvent)="email($event)"
                  label="Email Address"
                  placeholder="acme@xyz.com"
                ></app-input>
              </div>
              <div class="input-holder half-width">
                <app-input
                  class="input"
                  (dataEvent)="phoneNumber($event)"
                  label="Phone Number"
                  placeholder="+234 3234 3455"
                ></app-input>
              </div>
              <div class="input-holder full-width">
                <app-input
                  class="input"
                  (dataEvent)="companyName($event)"
                  label="Company Name"
                  placeholder="Ameh & Sons"
                ></app-input>
              </div>
              <div class="input-holder full-width">
                <app-input
                  class="input"
                  (dataEvent)="companyAddress($event)"
                  label="Company Address"
                  placeholder="Aminu Kano Crescent, Abuja"
                ></app-input>
              </div>
              <div class="input-holder half-width">
                <app-input
                  class="input"
                  (dataEvent)="password($event)"
                  type="password"
                  label="Password"
                  placeholder="*******"
                ></app-input>
              </div>
              <div class="input-holder half-width">
                <app-input
                  class="input"
                  (dataEvent)="confirmPassword($event)"
                  type="password"
                  label="Confirm Password"
                  placeholder="*******"
                ></app-input>
              </div>
            </div>
          </div>
          <div class="button-section">
            <app-button-fill
              [processLoading]="isLoading"
              [action]="register"
              buttonText="Create Account"
            ></app-button-fill>
          </div>
          <div class="create-account">
            <p>Already have an account! <a class="login-link" (click)="signin()">Signin →</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
